import { render, staticRenderFns } from "./Project15Zh.vue?vue&type=template&id=63b2a542&scoped=true&"
import script from "./Project15Zh.vue?vue&type=script&lang=js&"
export * from "./Project15Zh.vue?vue&type=script&lang=js&"
import style0 from "./Project15Zh.vue?vue&type=style&index=0&id=63b2a542&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2a542",
  null
  
)

export default component.exports